/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InternalAdminWhitelabelRequestV4SslCertificateDataOneOf interface.
 */
export function instanceOfInternalAdminWhitelabelRequestV4SslCertificateDataOneOf(value) {
    if (!('managed' in value) || value['managed'] === undefined)
        return false;
    return true;
}
export function InternalAdminWhitelabelRequestV4SslCertificateDataOneOfFromJSON(json) {
    return InternalAdminWhitelabelRequestV4SslCertificateDataOneOfFromJSONTyped(json, false);
}
export function InternalAdminWhitelabelRequestV4SslCertificateDataOneOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'managed': json['managed'],
    };
}
export function InternalAdminWhitelabelRequestV4SslCertificateDataOneOfToJSON(json) {
    return InternalAdminWhitelabelRequestV4SslCertificateDataOneOfToJSONTyped(json, false);
}
export function InternalAdminWhitelabelRequestV4SslCertificateDataOneOfToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'managed': value['managed'],
    };
}
